<template>
    <link-input shape="none" :type="type" :color="color" :size="size" v-model="filterValue.value" @enter="handleEnter" :placeholder="placeholder"
                @click-suffix-icon="pl_clear"/>
</template>

<script>
    export default {
        name: "link-auto-table-filter-input",
        props: {
            field: {},
            filterValue: {},

            size: {type: String,},
            color: {type: String,},
            type: {type: String,},
            placeholder: {type: String, default: '搜索关键字...'},
        },
        methods: {
            handleEnter() {
                this.$emit('confirm', {type: 'input', filtersRaw: this.getValue()});
            },
            getValue() {
                if (!this.filterValue.value) return null
                let value = this.filterValue.value
                let operator = 'LIKE'
                if (value.charAt(0) === '=') {
                    value = value.slice(1, value.length)
                    operator = '='
                }
                return {
                    id: this.field,
                    property: this.field,
                    value,
                    operator,
                }
            },
            async pl_clear() {
                await this.$lv.nextTick()
                this.handleEnter()
            },
        },
    }
</script>
